import { Label, Layout } from "@mcleod/components";

export abstract class AutogenLayoutPartnerProfileNotes extends Layout {
    labelNotes: Label;
}
